module.exports = __webpack_public_path__ + "img/1.670b3e8c.jpg";